module.exports = __webpack_public_path__ + "images/category_lp/brand/new/mainView-pc_892211021d72c0afba0fc5bd9c22ac3b.png";